import React, { useEffect } from "react";

import { createBrowserRouter, RouterProvider } from "react-router-dom";

import { PayPalScriptProvider } from "@paypal/react-paypal-js";
import { useDispatch, useSelector } from "react-redux";
import Home from "./ui/Home";

import AppLayout from "./ui/AppLayout";

import AuthService from "./services/auth.service";
import DashBoard from "./ui/DashBoard";
import AdminDashBoard from "./ui/AdminDashBoard";
import Login from "./features/users/Login";

import Menu from "./features/menuitems/Menu";
import Gallery from "./features/gallery/Gallery";
import FoodMenu, {
  loader as foodmenuLoader,
} from "./features/menuitems/FoodMenu";
import DrinksMenu from "./features/menuitems/DrinksMenu";
import CheckOut from "./features/cart/CheckOut";
import OrderPage from "./features/orders/OrderPage";
import Error from "./ui/Error";
import ListSocial from "./features/social/ListSocial";
import ListGallery from "./features/gallery/ListGallery";
import ListSlider from "./features/slider/ListSlider";
import EditSlider from "./features/slider/EditSlider";
import AddSlider from "./features/slider/AddSlider";
import ListShop from "./features/shop/ListShop";
import ListNavigation from "./features/navigation/ListNavigation";
import ListCategories from "./features/menucategory/ListCategories";
import ProductDetail from "./features/menuitems/ProductDetail";
import ListFood from "./features/menucategory/ListFood";
import ListDrink from "./features/menucategory/ListDrink";
import AddFoodDrinks from "./features/menucategory/AddFoodDrink";
import Profile from "./features/users/Profile";
import ListUser from "./features/users/ListUser";
import Register from "./features/users/Register";
import Sidebar from "./features/navigation/Sidebar";
import ForgotPassword from "./features/users/ForgotPassword";
import { setUser } from "./stores/user";
import ResetPassword from "./features/users/ResetPassword";
import EditFoodDrink from "./features/menucategory/EditFoodDrink";
import EditCategories from "./features/menucategory/EditCategories";
import AddCategories from "./features/menucategory/AddCategories";
import AddSocial from "./features/social/AddSocial";
import EditSocial from "./features/social/EditSocial";
import AddGallery from "./features/gallery/AddGallery";
import EditGallery from "./features/gallery/EditGallery";
import EditShop from "./features/shop/EditShop";

const router = createBrowserRouter([
  {
    element: <AppLayout />,
    errorElement: <Error />,

    children: [
      {
        path: "/",
        element: <Home />,
        errorElement: <Error />,
      },
      {
        path: "/menu",
        element: <Menu />,
        errorElement: <Error />,
      },
      {
        path: "/foodmenu",
        element: <FoodMenu />,
        loader: foodmenuLoader,
        errorElement: <Error />,
      },

      {
        path: "/foodmenu/:id",
        element: <ProductDetail />,
        errorElement: <Error />,
      },

      {
        path: "/drinksmenu/:id",
        element: <ProductDetail />,
        errorElement: <Error />,
      },

      {
        path: "/drinksmenu",
        element: <DrinksMenu />,
        errorElement: <Error />,
      },
      {
        path: "/gallery",
        element: <Gallery />,
        errorElement: <Error />,
      },

      {
        path: "/login",
        element: <Login />,
        errorElement: <Error />,
      },

      {
        path: "/forgotpassword",
        element: <ForgotPassword />,
        errorElement: <Error />,
      },

      {
        path: "/register",
        element: <Register />,
        errorElement: <Error />,
      },

      {
        path: "/resetpassword",
        element: <ResetPassword />,
        errorElement: <Error />,
      },

      {
        path: "/checkout",
        element: (
          <PrivateRoute>
            <CheckOut />
          </PrivateRoute>
        ),
        errorElement: <Error />,
      },

      {
        path: "/checkout/order/:id",
        element: (
          <PrivateRoute>
            <OrderPage />
          </PrivateRoute>
        ),
        errorElement: <Error />,
      },

      {
        path: "/dashboard",
        element: (
          <PrivateRoute>
            <DashBoard />
          </PrivateRoute>
        ),
        errorElement: <Error />,
      },

      {
        path: "/profile",
        element: (
          <PrivateRoute>
            <Profile />
          </PrivateRoute>
        ),
        errorElement: <Error />,
      },

      {
        path: "/admin/dashboard",
        element: (
          <AdminRoute>
            <Sidebar />
            <AdminDashBoard />
          </AdminRoute>
        ),
        errorElement: <Error />,
      },

      {
        path: "/admin/profile",
        element: (
          <AdminRoute>
            <Sidebar />
            <div>Admin profile coming soon..</div>
          </AdminRoute>
        ),
        errorElement: <Error />,
      },

      {
        path: "/admin",
        element: (
          <AdminRoute>
            <Sidebar />
            <ListShop />
          </AdminRoute>
        ),
        errorElement: <Error />,
      },

      {
        path: "/admin/user",
        element: (
          <AdminRoute>
            <Sidebar />
            <ListUser />
          </AdminRoute>
        ),
        errorElement: <Error />,
      },

      {
        path: "/admin/user/add",
        element: (
          <AdminRoute>
            <Sidebar />
            <ListFood />
          </AdminRoute>
        ),
        errorElement: <Error />,
      },

      {
        path: "/admin/food",
        element: (
          <AdminRoute>
            <Sidebar />
            <ListFood />
          </AdminRoute>
        ),
        errorElement: <Error />,
      },

      {
        path: "/admin/drinks",
        element: (
          <AdminRoute>
            <Sidebar />
            <ListDrink />
          </AdminRoute>
        ),
        errorElement: <Error />,
      },

      {
        path: "/admin/menucategories",
        element: (
          <AdminRoute>
            <Sidebar />
            <ListCategories />
          </AdminRoute>
        ),
        errorElement: <Error />,
      },

      {
        path: "/admin/menucategories/:id",
        element: (
          <AdminRoute>
            <Sidebar />
            <EditCategories />
          </AdminRoute>
        ),
        errorElement: <Error />,
      },

      {
        path: "/admin/menucategories/add",
        element: (
          <AdminRoute>
            <Sidebar />
            <AddCategories />
          </AdminRoute>
        ),
        errorElement: <Error />,
      },

      {
        path: "/admin/fooddrink/add",
        element: (
          <AdminRoute>
            <Sidebar />
            <AddFoodDrinks />
          </AdminRoute>
        ),
        errorElement: <Error />,
      },

      {
        path: "/admin/fooddrink/:id",
        element: (
          <AdminRoute>
            <Sidebar />
            <EditFoodDrink />
          </AdminRoute>
        ),
        errorElement: <Error />,
      },

      {
        path: "/admin/navigation",
        element: (
          <AdminRoute>
            <Sidebar />
            <ListNavigation />
          </AdminRoute>
        ),
        errorElement: <Error />,
      },

      {
        path: "/admin/navigation/add",
        element: (
          <AdminRoute>
            <Sidebar />
            <ListNavigation />
          </AdminRoute>
        ),
        errorElement: <Error />,
      },

      {
        path: "/admin/navigation/:id",
        element: (
          <AdminRoute>
            <Sidebar />
            <ListNavigation />
          </AdminRoute>
        ),
        errorElement: <Error />,
      },

      {
        path: "/admin/shop",
        element: (
          <AdminRoute>
            <Sidebar />
            <ListShop />
          </AdminRoute>
        ),
        errorElement: <Error />,
      },

      {
        path: "/admin/shop/:id",
        element: (
          <AdminRoute>
            <Sidebar />
            <EditShop />
          </AdminRoute>
        ),
        errorElement: <Error />,
      },

      {
        path: "/admin/slider/",
        element: (
          <AdminRoute>
            <Sidebar />
            <ListSlider />
          </AdminRoute>
        ),
        errorElement: <Error />,
      },

      {
        path: "/admin/slider/add",
        element: (
          <AdminRoute>
            <Sidebar />
            <AddSlider />
          </AdminRoute>
        ),
        errorElement: <Error />,
      },

      {
        path: "/admin/slider/:id",
        element: (
          <AdminRoute>
            <Sidebar />
            <EditSlider />
          </AdminRoute>
        ),
        errorElement: <Error />,
      },

      {
        path: "/admin/gallery/",
        element: (
          <AdminRoute>
            <Sidebar />
            <ListGallery />
          </AdminRoute>
        ),
        errorElement: <Error />,
      },

      {
        path: "/admin/gallery/add",
        element: (
          <AdminRoute>
            <Sidebar />
            <AddGallery />
          </AdminRoute>
        ),
        errorElement: <Error />,
      },

      {
        path: "/admin/gallery/:id",
        element: (
          <AdminRoute>
            <Sidebar />
            <EditGallery />
          </AdminRoute>
        ),
        errorElement: <Error />,
      },

      {
        path: "/admin/social/",
        element: (
          <AdminRoute>
            <Sidebar />
            <ListSocial />
          </AdminRoute>
        ),
        errorElement: <Error />,
      },

      {
        path: "/admin/social/add",
        element: (
          <AdminRoute>
            <Sidebar />
            <AddSocial />
          </AdminRoute>
        ),
        errorElement: <Error />,
      },

      {
        path: "/admin/social/:id",
        element: (
          <AdminRoute>
            <Sidebar />
            <EditSocial />
          </AdminRoute>
        ),
        errorElement: <Error />,
      },
    ],
  },
]);

function PrivateRoute({ children }) {
  const auth = useSelector((store) => store.user);

  // const isAuthenticated = checkUserAuthentication();
  const isAuthenticated = auth.token ? true : false;
  const isNotAdmin = auth.role === null || "";
  const isAuthenticatedNotadmin = isAuthenticated && isNotAdmin;
  // console.log("isAuthenticatedNotadmin ", isAuthenticatedNotadmin);
  return isAuthenticatedNotadmin ? <div>{children}</div> : <Login />;
}

function AdminRoute({ children }) {
  const user = useSelector((store) => store.user);
  const isAuthenticatedAdmin =
    user.token && user.role === "admin" ? true : false;
  // console.log("isAuthenticatedAdmin ", isAuthenticatedAdmin);
  return isAuthenticatedAdmin ? (
    <div className="flex col-2 ">{children}</div>
  ) : (
    <Login />
  );
}

function App() {
  const dispatch = useDispatch();
  const options = {
    "client-id":
      "AesI6TWdaVQzfUgsg_khEz_mL9DzI35O_ShcLRA3BGFL9zmZKxYd0cIsdyhd3xojnPZQU3WkknxGCAc7",
    currency: "HKD",
    intent: "capture",
  };

  const getUser = () => {
    const user = AuthService.getCurrentUser();
    if (user) {
      dispatch(setUser(user));
    } else {
      console.log("user at:" + JSON.stringify(user));
    }
  };

  useEffect(() => {
    getUser();
  });

  return (
    <PayPalScriptProvider options={options}>
      <RouterProvider router={router} />
    </PayPalScriptProvider>
  );
}

export default App;
